import { ProductCard, Product } from './ProductCard';
import { Package } from 'lucide-react';

interface ProductGridProps {
  products: Product[];
  onAddToCart: (product: Product) => void;
  layout?: 'grid' | 'list' | 'compact';
  gridSize?: '2x3' | '3x4' | '4x6';
}

export const ProductGrid = ({
  products,
  onAddToCart,
  layout = 'grid',
  gridSize = '3x4',
}: ProductGridProps) => {
  const getGridCols = () => {
    switch (gridSize) {
      case '2x3':
        return 'grid-cols-2';
      case '3x4':
        return 'grid-cols-3';
      case '4x6':
        return 'grid-cols-4';
      default:
        return 'grid-cols-3';
    }
  };

  if (products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-gray-400">
        <Package className="w-24 h-24 mb-4 opacity-20" />
        <p className="text-lg font-medium">لا توجد منتجات</p>
        <p className="text-sm">Aucun produit trouvé</p>
      </div>
    );
  }

  return (
    <div className={`grid ${getGridCols()} gap-4`}>
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onAddToCart={onAddToCart}
          layout={layout}
        />
      ))}
    </div>
  );
};
